<div class="flex">
  <div class="img-fundo"></div>
</div>
